import React from "react";
import { Check } from "./LpIcons";

/** Checkbox with label. Controlled via `checked` / `onChange`. */
function LpCheckbox({ checked = false, onChange, label, disabled = false, className = "", ...rest }) {
  const cls = ["lp-checkbox", disabled && "lp-checkbox--disabled", className].filter(Boolean).join(" ");
  return (
    <label className={cls}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} {...rest} />
      <span className="lp-checkbox__box"><Check /></span>
      {label && <span>{label}</span>}
    </label>
  );
}

export default React.memo(LpCheckbox);
